module.exports = __webpack_public_path__ + "img/selenium.9c598db2.png";